// axios.js
import axios from 'axios';
import store from '@/store/index';

export function axiosDefault(config, cancelToken) {
  const instance = axios.create({
    baseURL: config.WebApiUrl,
  });

  instance.interceptors.request.use((config) => {
    if (cancelToken) {
      config.cancelToken = cancelToken;
    }
    return config;
  });

  return instance;
}

export function axiosWAuth(config, cancelToken) {
  const instance = axios.create({
    baseURL: config.WebApiUrl,
    withCredentials: true,
  });

  instance.interceptors.request.use(
    config => {
      config.headers.common = {
        ...config.headers.common,
        Authorization: 'Bearer ' + store.getters.getAccessToken,
      };
      if (cancelToken) {
        config.cancelToken = cancelToken;
      }
      return config;
    },
    error => Promise.reject(error),
  );

  //Check responses for 401 response (reach out to refresh token here when we get refresh token)
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        store.dispatch("logout");
        window.location.href = config.WebCaatAuthWebUrl + "?returnUrl=" + config.FrontendUrl;
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    },
  );

  return instance;
}
